import React from "react";
import { Grid, TextField, Typography } from "@mui/material";
import LabelledBox from "../../../../../../../components/widgets/LabelledBox";
import CopyUrlButton from "../../../../../../../components/btns/CopyLinkBtn";
import { usePOPageContext } from "./POPageContext";

const poDetailsGrid = [
  {
    label: "Plant Name",
    field: "plant",
    grid: 0.8,
  },
  {
    label: "MRQ",
    field: "mrqNumber",
    grid: 0.6,
  },
  {
    label: "Made By",
    field: "drawnBy",
    grid: 0.8,
  },
  {
    label: "Date",
    field: "poDate",
    grid: 0.5,
  },
  {
    label: "PO Number",
    field: "poNumber",
    grid: 0.8,
  },
  {
    label: "PO Rev",
    field: "rev",
    grid: 0.6,
  },
  {
    label: "Title",
    field: "title",
    grid: 0.8,
  },
  {
    label: "Vendor Name",
    field: "vendorName",
    grid: 0.8,
  },

  {
    label: "Vendor Email",
    field: "vendorEmail",
    grid: 0.8,
  },
];

export default function PoDetails({ po, addCopyBtn = true }) {
  const { plantId } = usePOPageContext();

  const poDetails = {
    ...po,
    mrqNumber: po?.mrq?.mrqNumber,
    vendorName: po.poMaterials?.[0]?.vendor?.name,
    vendorEmail: po.poMaterials?.[0]?.vendor?.email,
  };

  const link = `/plant/${plantId}/po/${po?.id}`;

  return (
    <LabelledBox
      label="PO Details"
      sx={{ display: "inline-block", position: "relative", mt: 4 }}
    >
      {po?.id && addCopyBtn && (
        <CopyUrlButton
          label="Copy PO Link"
          sx={{ position: "absolute", top: -40, right: 5 }}
          subLink={link}
        />
      )}
      {po?.id && addCopyBtn && (
        <Typography
          sx={{ position: "absolute", top: 5, right: 10, color: "#888" }}
        >
          ID: {po?.id}
        </Typography>
      )}
      <Grid container spacing={2} columns={{ xs: 6.8 }} sx={{ width: "500px" }}>
        {poDetailsGrid.map((item, index) => (
          <React.Fragment key={index}>
            <Grid item xs={item.grid}>
              <Typography>{item.label}</Typography>
            </Grid>
            <Grid
              item
              xs={
                ["Title", "Vendor Email", "Vendor Name"].includes(item.label)
                  ? 5.5
                  : 2.5
              }
            >
              <TextField
                id="outlined-basic"
                variant="outlined"
                hiddenLabel
                size="small"
                disabled
                fullWidth
                value={poDetails?.[item.field]}
                inputProps={{ sx: { padding: "2px", pl: "5px" } }}
              />
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </LabelledBox>
  );
}
